import React from 'react';
import Card from '../../components/ui/Card';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export default function GuideInscriptionPage() {
  const documents = [
    "Original du Baccalauréat (+ copies légalisées)",
    "Relevés de notes du Bac (et post-bac si admission parallèle)",
    "Extrait d'acte de naissance récent",
    "Copie du Passeport (valide pour au moins 1 an)",
    "Extrait de casier judiciaire (moins de 3 mois)",
    "Certificat médical d'aptitude physique",
    "Photos d'identité récentes (format passeport)"
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-8 animate-fade-in">
      <Card variant="default" className="p-6 sm:p-8 space-y-3">
        <h2 className="font-title text-xl sm:text-2xl font-bold text-acem-primary-dark">
          Avant-propos
        </h2>
        <p className="text-sm sm:text-base text-acem-text/90 leading-relaxed">
          Ce guide vous détaille toutes les démarches nécessaires pour réussir votre inscription au sein des établissements d'enseignement supérieur au Maroc, et plus particulièrement à Fès. L'ACEM Fès se tient à votre entière disposition pour vous accompagner à chaque étape.
        </p>
      </Card>

      <div className="space-y-6">
        {/* Étape 1 */}
        <Card variant="elevated" className="p-6 sm:p-8 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-acem-primary text-white font-title text-xl font-bold flex items-center justify-center flex-shrink-0 shadow-sm">
              1
            </div>
            <h3 className="font-title text-lg sm:text-xl font-bold text-acem-text">
              Le choix du canal d'admission
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
            <div className="bg-acem-surface-container-low p-5 rounded-xl border border-acem-border/60 space-y-2">
              <h4 className="font-title font-bold text-acem-primary text-base">
                Canal Officiel (AMCI)
              </h4>
              <p className="text-xs sm:text-sm text-acem-text/90 leading-relaxed">
                Principalement pour les boursiers et étudiants du secteur public. La candidature se fait via l'Agence Marocaine de Coopération Internationale (AMCI) par l'intermédiaire du Ministère de l'Éducation de votre pays.
              </p>
              <p className="text-xs text-acem-muted italic pt-1">
                <strong>Note :</strong> Période usuelle de candidatures : mai-juillet.
              </p>
            </div>

            <div className="bg-acem-surface-container-low p-5 rounded-xl border border-acem-border/60 space-y-2">
              <h4 className="font-title font-bold text-acem-primary text-base">
                Canal Direct
              </h4>
              <p className="text-xs sm:text-sm text-acem-text/90 leading-relaxed">
                Destiné principalement aux instituts privés ou certaines grandes écoles sur concours. Vous devez postuler directement en ligne sur les plateformes des universités concernées.
              </p>
              <p className="text-xs text-acem-muted italic pt-1">
                <strong>Note :</strong> Veillez à respecter scrupuleusement les dates limites propres à chaque école.
              </p>
            </div>
          </div>
        </Card>

        {/* Étape 2 */}
        <Card variant="elevated" className="p-6 sm:p-8 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-acem-primary text-white font-title text-xl font-bold flex items-center justify-center flex-shrink-0 shadow-sm">
              2
            </div>
            <h3 className="font-title text-lg sm:text-xl font-bold text-acem-text">
              Préparation du dossier administratif
            </h3>
          </div>

          <p className="text-xs sm:text-sm text-acem-muted">
            Assurez-vous d'avoir les originaux ainsi que plusieurs copies certifiées conformes (légalisées).
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
            {documents.map((doc, idx) => (
              <div
                key={idx}
                className="flex items-start gap-2.5 bg-acem-surface-container-low p-3.5 rounded-xl border border-acem-border/50 text-xs sm:text-sm text-acem-text"
              >
                <CheckCircleIcon className="w-5 h-5 text-acem-primary flex-shrink-0 mt-0.5" aria-hidden="true" />
                <span>{doc}</span>
              </div>
            ))}
          </div>
        </Card>

        {/* Étape 3 */}
        <Card variant="elevated" className="p-6 sm:p-8 space-y-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-acem-primary text-white font-title text-xl font-bold flex items-center justify-center flex-shrink-0 shadow-sm">
              3
            </div>
            <h3 className="font-title text-lg sm:text-xl font-bold text-acem-text">
              Arrivée et accueil à Fès
            </h3>
          </div>

          <div className="bg-acem-surface-container-low p-5 rounded-xl border border-acem-border/60 space-y-3 text-xs sm:text-sm text-acem-text/90 leading-relaxed">
            <p>
              Dès votre arrivée à l'aéroport de Fès-Saïss ou à la gare ferroviaire avec votre lettre d'admission (autorisation d'inscription AMCI) et votre dossier complet, <strong>le bureau de l'ACEM Fès prend le relais</strong>.
            </p>
            <p className="text-xs text-acem-muted italic">
              <strong>Accompagnement :</strong> Nous organisons des journées d'accueil pour vous orienter dans les facultés, vous aider à finaliser l'inscription administrative, trouver un logement sécurisé, et réussir votre intégration dans la ville de Fès.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
